// =====================================================================
// Utilitários de data da Agenda Corporativa (Teams/M365)
// =====================================================================
// Compartilhados pelas duas apresentações da agenda: o card em lista
// (AgendaCorporativa, na Home) e o grid de mês (CalendarioAgenda, no modal do
// ícone de calendário). Moravam dentro da AgendaCorporativa.

// Formata 'YYYY-MM-DDTHH:mm:ss(.fff)' (vem do Graph já em horário de Brasília)
// para exibição. Tratamos como horário local — sem aplicar fuso de novo.
export const parseLocal = (s) => {
    if (!s) return null;
    const [data, hora] = s.split('T');
    const [a, m, d] = data.split('-').map(Number);
    const [hh = 0, mm = 0] = (hora || '').split(':').map(Number);
    return new Date(a, m - 1, d, hh, mm);
};

export const horaBR = (dt) => dt ? dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : '';

const ROTULO_DIA = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

// Cabeçalho de grupo da lista: "Hoje" / "Amanhã" / "Quinta, 23/07".
export const tituloDia = (dt) => {
    const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
    const alvo = new Date(dt); alvo.setHours(0, 0, 0, 0);
    const difDias = Math.round((alvo - hoje) / 86400000);
    if (difDias === 0) return 'Hoje';
    if (difDias === 1) return 'Amanhã';
    return `${ROTULO_DIA[alvo.getDay()]}, ${alvo.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })}`;
};

// Valor para <input type="datetime-local"> (ex.: próxima hora cheia).
export const inputDateTime = (dt) => {
    const p = (n) => String(n).padStart(2, '0');
    return `${dt.getFullYear()}-${p(dt.getMonth() + 1)}-${p(dt.getDate())}T${p(dt.getHours())}:${p(dt.getMinutes())}`;
};

// Formulário em branco para um compromisso NOVO. `dia` (opcional) ancora o
// compromisso numa data — o grid usa ao clicar no "+" de uma célula; sem ele
// (card da Home), cai na próxima hora cheia de hoje.
export const novoCompromisso = (dia) => {
    const base = dia ? new Date(dia) : new Date();
    if (dia) {
        // Dia clicado no grid: sugere 09:00, hora de abertura típica.
        base.setHours(9, 0, 0, 0);
    } else {
        base.setMinutes(0, 0, 0);
        base.setHours(base.getHours() + 1);
    }
    const depois = new Date(base.getTime() + 60 * 60 * 1000);
    // recorrencia.tipo 'nenhuma' = compromisso avulso (o default). Só a criação
    // oferece recorrência; ver FormCompromisso.
    return {
        assunto: '', inicio: inputDateTime(base), fim: inputDateTime(depois),
        local: '', participantes: '', online: false,
        recorrencia: { tipo: 'nenhuma', diaSemana: '', ate: '' },
    };
};

// Preenche o formulário a partir de um compromisso existente (edição).
// SÉRIE RECORRENTE: o calendarView devolve cada OCORRÊNCIA (tipo='occurrence')
// apontando para o mestre (serieMestreId). Editar/excluir precisa mirar o MESTRE
// — mexer numa ocorrência solta quase nunca é o que se quer num lembrete semanal.
// Por isso, quando é ocorrência, o `id` do form vira o do mestre e marcamos
// `serie: true` (a tela então edita só campos seguros e mostra o aviso).
export const compromissoParaForm = (ev) => {
    const serie = (ev.tipo === 'occurrence' && !!ev.serieMestreId) || ev.tipo === 'seriesMaster';
    return {
        id: serie && ev.tipo === 'occurrence' ? ev.serieMestreId : ev.id,
        serie,
        assunto: ev.assunto === '(sem título)' ? '' : ev.assunto,
        inicio: ev.inicio ? ev.inicio.slice(0, 16) : '',
        fim: ev.fim ? ev.fim.slice(0, 16) : '',
        local: ev.local || '',
        participantes: (ev.participantes || []).join(', '),
        online: !!ev.online,
    };
};
